












































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { TooltipPrompt } from '@/components/Prompt/index'
import { TagsInput } from '@/components/Form'
import Table from '@/components/Table/index.vue'
import SyncMapDialog from './components/SyncMapDialog'

import {
    getMapDetail,
    publishMap,
} from '@/service/project-management/map';
import { MapAliasType, MapType } from './types';

@Component({
    components: {
        TooltipPrompt,
        TagsInput,
        Table,
        SyncMapDialog,
    },
})
export default class Edit extends Vue {
    @Ref()
    readonly syncMapDialogEl: SyncMapDialog

    get currentID() {
        return this.$route.params.mapID;
    }

    get name() {
        return this.mapInfo ? this.mapInfo.name : ''
    }

    loading = false
    mapInfo: MapType = {} as MapType
    mapAliasInfo: MapAliasType[] = []
    syncMapDialogVisible = false;

    beforeMount() {
        this.getDetail();
    }

    getDetail() {
        const params = {
            mapId: this.currentID,
        };
        this.loading = true;
        getMapDetail(params).then(({ data }) => {
            const { fictitiousMap, mapAliasList } = data;
            this.mapInfo = fictitiousMap || {}
            this.mapAliasInfo = mapAliasList
                ? mapAliasList
                : []
            if (this.mapAliasInfo.length === 0) {
                this.handleAddAlias()
            }
        }).finally(() => {
            this.loading = false;
        })
    }

    goBack() {
        this.$router.push({
            name: '项目管理_项目详情_地图管理_列表',
        });
    }

    handleSyncMap() {
        this.syncMapDialogVisible = true
    }

    handleAddAlias() {
        this.mapAliasInfo.push({
            code: '',
            name: '',
            synonyms: [],
        })
    }

    handlePublish() {
        // 校验数据
        if (!this.validate()) {
            return;
        }
        this.$confirm(
            '请确认是否发布？',
            '提示',
            {
                customClass: 'rop-confirm-box',
                cancelButtonClass: 'rop-btn size-dialog light',
                confirmButtonClass: 'rop-btn size-dialog dark',
            },
        ).then(() => {
            this.loading = true;
            const data = {
                fictitiousMap: _.pick(this.mapInfo, ['id', 'bindingDevices']),
                mapAliasList: this.mapAliasInfo
                    .filter(d => !this.isEmptyItem(d))
                    .map(d => _.pick(d, ['code', 'name', 'synonyms'])),
            };
            publishMap(data).then(() => {
                this.$message.success('发布成功');
                this.goBack();
            }).finally(() => {
                this.loading = false;
            })
        }).catch(() => {
            return;
        });
    }

    handleDeleteAlias(index) {
        this.$confirm(
            '请确认是否删除？',
            '提示',
            {
                customClass: 'rop-confirm-box',
                cancelButtonClass: 'rop-btn size-dialog light',
                confirmButtonClass: 'rop-btn size-dialog dark',
            },
        ).then(() => {
            this.mapAliasInfo.splice(index, 1);
        }).catch(() => {
            return;
        });
    }

    handleCloseSyncMapDialog() {
        this.syncMapDialogVisible = false
    }

    handleSubmitSyncMapDialog({deviceId, mapData}) {
        this.handleCloseSyncMapDialog();
        this.mapInfo.bindingDevices = [deviceId]
        this.renderMap(mapData)
    }

    renderMap(mapData) {
        const newMapDataList = mapData.map(d => ({
            id: d,
            code: d,
            name: '',
            synonyms: [],
        }))
        if (this.mapAliasInfo) {
            this.mapAliasInfo = newMapDataList.map(newMapDataItem => {
                const originMapItem = _.find(this.mapAliasInfo, { code: newMapDataItem.code })
                return originMapItem || newMapDataItem
            })
        } else {
            this.mapAliasInfo = newMapDataList
        }
    }

    validate() {
        if (this.mapAliasInfo.filter(d => !this.isEmptyItem(d)).length < 1) {
            this.$message.warning('地图列表无数据，请手动添加或选择同步地图');
            return false
        }
        let nameList = [], codeList = []
        for (const [index, item] of this.mapAliasInfo.entries()) {
            if (!this.validateItem(item, index)) {
                return false
            }

            const { name, code } = item
            /*if (nameList.includes(name)) {
                this.$message.warning(`位置名称"${name}"重复，请重新输入`);
                return false
            }
            nameList.push(name)*/

            if (codeList.includes(code)) {
                this.$message.warning(`位置名称"${code}"重复，请重新输入`);
                return false
            }
            codeList.push(code)
        }
        return true
    }
    validateItem(item, index) {
        const validateCodeRule = value => {
            const regex = /^[_a-zA-Z0-9]+$/g;
            return regex.test(value);
        };
        if (this.isEmptyItem(item)) {
            return true
        }
        /*if (!item.name) {
            if (item.code) {
                this.$message.warning(`请输入位置标识"${item.code}"的位置名称`);
            } else {
                this.$message.warning(`请输入第${index + 1}行的位置名称`);
            }
            return false;
        } else if (!item.code) {
            this.$message.warning(`请输入位置名称"${item.name}"的位置标识`);
            return false;
        }*/
        if (!item.code) {
            this.$message.warning(`请输入位置名称`);
            return false;
        }
        // 同步的code可能不满足校验，暂时屏蔽
        // else if (!validateCodeRule(item.code)) {
        //     this.$message.warning(`"${item.name}"的位置标识不规范，标识只能输入英文，数字及下划线`);
        //     return false;
        // }
        return true;
    }
    isEmptyItem(item) {
        // return !item.name && !item.code && (!_.isArray(item.synonyms) || item.synonyms.length < 1)
        return !item.code && (!_.isArray(item.synonyms) || item.synonyms.length < 1)
    }
}
